/**
 * Indentáció / behúzás normalizására.
 * @param {string} str - A szöveg, amit normalizálni szeretnénk.
 * @param {number} [indent=2] - A behúzás mértéke.
 * @returns {string} A normalizált szöveg.
 */
module.exports.indentNormalize = function indentNormalize (str, indent = 2) {
  const lines = str.trim().split('\n')

  let spaces = 0

  const res = lines.map((line) => {
    const tmp = line.trim()
    const isEmpty = tmp.length <= 0

    spaces = tmp.startsWith('}') ? spaces - indent : spaces

    const newLine = isEmpty ? tmp : `${ ' '.repeat(spaces) }${ tmp }`
    spaces = tmp.endsWith('{') ? spaces + indent : spaces

    return newLine
  })

  return res.join('\n')
}
